import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody
} from "reactstrap";
import { useHistory } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";

const Coaching = () => {
  const history = useHistory();

  const tiles = [
    {
      title: "Menu Management",
      description: "Manage dishes and training cards",
      icon: "ri-menu-line",
      bg: "bg-gradient-orange",
      path: "/menu-management"
    },
    {
      title: "Servers",
      description: "Manage servers and assign trainings",
      icon: "ri-user-3-line",
      bg: "bg-gradient-green",
      path: "/server-management"
    },
    {
      title: "Flash Cards",
      description: "Study with interactive flash cards",
      icon: "ri-bank-card-line",
      bg: "bg-gradient-blue",
      path: "/flash-cards"
    },
    {
      title: "Training Videos",
      description: "View and manage training videos",
      icon: "ri-video-line",
      bg: "bg-gradient-pink",
      path: "/training-videos"
    }
  ];

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Server Performance Coaching" pageTitle="Dashboard" />

        {/* Heading */}
        <div className="text-center my-2">
          <h2 className="fw-bold">Welcome to Server Performance Coaching</h2>
          <p className="text-muted">Select a section to get started</p>
        </div>

        {/* Tiles */}
        <Row className="justify-content-center mb-4">
          <Col lg="8">
            <Row className="g-4">
              {tiles.map((tile, index) => (
                <Col md="6" key={index}>
                  <Card
                    className="coaching-card h-100"
                    onClick={() => history.push(tile.path)}
                  >
                    <CardBody className="text-center p-4">
                      <div className={`icon-circle ${tile.bg}`}>
                        <i className={`${tile.icon} text-white fs-3`} />
                      </div>

                      <h5 className="mt-4 fw-bold">{tile.title}</h5>
                      <p className="text-muted mb-0">
                        {tile.description}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default Coaching;
